@if (!isLoading && message) {
  <sb-alert
    [message]="message"
    [isMessageTranslated]="false"
    alertClass="warning"
    [hideOnDismiss]="true"
  [collapseConfig]="alertCollapseConfig"></sb-alert>
}
<sb-loading [hasLoaded]="!isLoading"></sb-loading>
